import React, { useEffect, useState } from "react";
import styles from "../../../styles/brsr/general.module.css";
import {
  Box,
  Button,
  Chip,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Stack,
  TextField,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { get, put } from "../../../utils/api";
import { useParams } from "react-router-dom";
import { brsrReview } from "../../../utils/companyId";
import ReviewBox from "../../Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";
import EastIcon from "@mui/icons-material/East";

const Details = ({ onSave, hide, downloadMode }) => {
  const { id } = useParams();

  const [formData, setFormData] = useState({
    corporateIdentityNumber: "",
    listedCompanyName: "",
    yearOfIncorporation: "",
    registeredOfficeAddress: "",
    corporateOfficeAddress: "",
    companyEmail: "",
    companyTelephoneNumber: "",
    companyWebsite: "",
    financialYear: "",
    stockExchanges: [],
    paidUpCapital: "",
    queryContact: {
      name: "",
      telephone: "",
      email: "",
    },
    reportingBoundary: "Standalone",
    assuranceProvider: "",
    assuranceType: "",
  });
  const [newLocation, setNewLocation] = useState("");
  const [error, setErrors] = useState({});
  const [disabled, setDisabled] = useState(false);

  const fetchData = async () => {
    try {
      const res = await get(`/brsr/get?type=SectionA&id=${id}`);
      if (
        res?.data?.data?.year
          ? res?.data?.data?.year < currentYear - 1
          : false || !brsrReview
      )
        setDisabled(true);
      const res1 = res?.data?.data?.BRSRSectionA?.listedIdentity;
      setFormData((prev) => ({
        ...prev,
        ...res1,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleInputChange = (e, type) => {
    const { name, value } = e.target;

    if (type === "number") {
      if (!/^\d*$/.test(value)) return;
    }
    setErrors((prev) => ({ ...prev, [name]: "" }));

    if (name.startsWith("queryContact.")) {
      setErrors((prev) => ({ ...prev, [field]: "" }));

      const field = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        queryContact: { ...prev.queryContact, [field]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const renderTextField = (label, name, heading, type = "text") => (
    <Grid item xs={12} md={6}>
      <p className={styles.title}>{heading}</p>
      <TextField
        fullWidth
        placeholder={label}
        disabled={disabled}
        name={name}
        value={formData[name]}
        onChange={(e) => handleInputChange(e, type)}
        // type={type}
        size="small"
        sx={{
          "& .MuiOutlinedInput-root": {
            border: `1px solid ${error[name] ? "#D34040" : "#74757E"}`,
            borderRadius: "4px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&:hover .MuiOutlinedInput-root": {
            border: `1px solid ${error[name] ? "#D34040" : "#5A5B65"}`,
          },
          "&.Mui-focused .MuiOutlinedInput-root": {
            border: `1px solid ${error[name] ? "#D34040" : "#2D2F38"}`,
          },
        }}
        error={!!error[name]} // Show error if exists
        helperText={error[name] || ""}
        FormHelperTextProps={{
          sx: {
            marginLeft: 0, // ✅ removes left margin
          },
        }}
        // InputLabelProps={{
        //   sx: {
        //     color: "#45464F",
        //     fontWeight: "400",
        //   },
        // }}
      />
    </Grid>
  );

  const handleAddLocation = () => {
    if (newLocation.trim() && !formData.stockExchanges.includes(newLocation)) {
      setFormData((prevData) => ({
        ...prevData,
        stockExchanges: [...prevData.stockExchanges, newLocation.trim()],
      }));
      setNewLocation("");
    }
  };

  const handleDeleteLocation = (locationToDelete) => {
    setFormData((prevData) => ({
      ...prevData,
      stockExchanges: prevData.stockExchanges.filter(
        (loc) => loc !== locationToDelete
      ),
    }));
  };

  const renderMultiSelect = ({ hide }) => (
    <Grid item xs={12} md={6}>
      <p>10. Name of Stock Exchange(s) where shares are listed </p>
      {!hide && (
        <TextField
          value={newLocation}
          onChange={(e) => setNewLocation(e.target.value)}
          placeholder="Type Here"
          disabled={disabled}
          fullWidth
          error={!!error["stockExchanges"]} // Show error if exists
          helperText={error["stockExchanges"] || ""}
          FormHelperTextProps={{
            sx: {
              marginLeft: 0, // ✅ removes left margin
            },
          }}
          sx={{
            "& .MuiInputBase-root": {
              minHeight: "2.7rem",
            },
            "& .MuiInputBase-input": {
              padding: "6px 14px",
            },
          }}
        />
      )}
      {!hide && (
        <div style={{ display: "flex", justifyContent: "end" }}>
          <Button
            // disabled={isFilled?.[tableIndex]}
            disabled={disabled}
            endIcon={<Add />}
            onClick={handleAddLocation}
            sx={{
              color: "#1C486B",
              // width: "7rem",
              borderColor: "#1C486B",
              marginTop: "10px",
            }}
            variant="outlined"
          >
            Add
          </Button>
        </div>
      )}

      <Stack direction="row" spacing={hide ? 2 : 1} mt={2}>
        {formData?.stockExchanges?.map((location, index) => (
          <Chip
            key={index}
            label={location?.toString()}
            disabled={disabled}
            {...(!hide && { onDelete: () => handleDeleteLocation(location) })}
          />
        ))}
      </Stack>
    </Grid>
  );

  const renderYearPicker = (label, name) => (
    <Grid item xs={12} md={6}>
      <p>{label}</p>
      {hide ? (
        <TextField
          fullWidth
          disabled={disabled}
          name="queryContact.name"
          placeholder="Enter Name"
          size="small"
          value={
            formData[name]
              ? dayjs(`${formData[name]}-01-01`).format("YYYY")
              : "-"
          }
          onChange={handleInputChange}
          error={!!error["name"]} // Show error if exists
          helperText={error["name"] || ""}
          FormHelperTextProps={{
            sx: {
              marginLeft: 0, // ✅ removes left margin
            },
          }}
        />
      ) : (
        <LocalizationProvider dateAdapter={AdapterDayjs} sx={{ margin: "0" }}>
          {/* <DatePicker
            disabled={disabled}
            // sx={{ width: "100%", margin: "0" }}
            views={["year"]}
            label={"Select Year"}
            // placeholder="Select Year"
            size="small"
            value={formData[name] ? dayjs(`${formData[name]}-01-01`) : null}
            onChange={(newValue) => {
              setFormData((prev) => ({
                ...prev,
                [name]: newValue?.year() || "",
              }));
            }}
            // minDate={dayjs().subtract(10, "year")}
            maxDate={dayjs()}
            sx={{
              width: "100%",
              margin: "0",
              "& .MuiInputBase-root": {
                minHeight: "2.7rem",
                fontSize: "13px",
              },
              "& .MuiInputBase-input": {
                padding: "6px 14px",
              },
            }}
            renderInput={(params) => (
              <TextField {...params} fullWidth size="small" />
            )}
          /> */}
          <TextField
            select
            fullWidth
            size="small"
            name={name}
            disabled={disabled}
            value={formData[name] || ""}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                [name]: parseInt(e.target.value),
              }))
            }
            error={!!error[name]}
            helperText={error[name] || ""}
            FormHelperTextProps={{
              sx: { marginLeft: 0 },
            }}
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  sx: {
                    maxHeight: 200, // ↓ reduce dropdown height
                  },
                },
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null, // ↓ ensures dropdown appears directly below
              },
            }}
            sx={{
              "& .MuiInputBase-root": {
                minHeight: "2.7rem",
              },
              "& .MuiInputBase-input": {
                padding: "6px 14px",
              },
            }}
          >
            {[...Array(126)].map((_, index) => {
              const year = new Date().getFullYear() - index;
              return (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              );
            })}
          </TextField>
        </LocalizationProvider>
      )}
    </Grid>
  );

  const validateForm = (form) => {
    let errors = {};

    if (!form.corporateIdentityNumber) {
      errors.corporateIdentityNumber = "Corporate Identity Number is required.";
    }
    if (!form.listedCompanyName) {
      errors.listedCompanyName = "Listed Company Name is required.";
    }
    if (!form.yearOfIncorporation) {
      errors.yearOfIncorporation = "Year of Incorporation is required.";
    }
    if (!form.registeredOfficeAddress) {
      errors.registeredOfficeAddress = "Registered Office Address is required.";
    }
    if (!form.corporateOfficeAddress) {
      errors.corporateOfficeAddress = "Corporate Office Address is required.";
    }
    // if (!form.companyEmail) {
    //   errors.companyEmail = "Company Email is required.";
    // }
    if (!form.companyEmail) {
      errors.companyEmail = "Company Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.companyEmail)) {
      errors.companyEmail = "Enter a valid email address.";
    }
    if (!form.companyTelephoneNumber) {
      errors.companyTelephoneNumber = "Company Telephone Number is required.";
    }
    // if (!form.companyWebsite) {
    //   errors.companyWebsite = "Company Website is required.";
    // }
    if (!form.companyWebsite) {
      errors.companyWebsite = "Company Website is required.";
    } else if (
      !/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/.test(
        form.companyWebsite
      )
    ) {
      errors.companyWebsite = "Enter a valid website URL.";
    }
    if (!form.financialYear) {
      errors.financialYear = "Financial Year is required.";
    }
    if (!form.paidUpCapital) {
      errors.paidUpCapital = "Paid-Up Capital is required.";
    }
    if (!form.assuranceProvider) {
      errors.assuranceProvider = "Assurance Provider is required.";
    }
    if (!form.assuranceType) {
      errors.assuranceType = "Assurance Type is required.";
    }

    // Stock Exchanges: Should not be empty array
    if (
      !Array.isArray(form.stockExchanges) ||
      form.stockExchanges.length === 0
    ) {
      errors.stockExchanges = "At least one Stock Exchange is required.";
    }

    // Query Contact Fields
    if (!form.queryContact.name) {
      errors.name = "Contact Name is required.";
    }
    // if (!form.queryContact.telephone) {
    //   errors.telephone = "Contact Telephone is required.";
    // }
    // if (!form.queryContact.email) {
    //   errors.email = "Contact Email is required.";
    // }
    if (!form.queryContact.telephone) {
      errors.telephone = "Contact Telephone is required.";
    } else if (!/^\d+$/.test(form.queryContact.telephone)) {
      errors.telephone = "Enter a valid Telephone number.";
    }

    if (!form.queryContact.email) {
      errors.email = "Company Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.queryContact.email)) {
      errors.email = "Enter a valid email address.";
    }
    setErrors(errors);

    return Object.keys(errors).length > 0 ? errors : false;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (validateForm(formData)) return;
      await put(`/brsr/update?id=${id}`, {
        listedIdentity: formData,
        listedIdentitySubmitted: true,
        type: "SectionA",
      })
        .then((res) => {
          onSave();
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else onSave();
  };

  return (
    <div>
      <p className={styles.subHeading}>I. DETAILS OF THE LISTED ENTITY</p>
      <Grid container spacing={2}>
        {/* Text Fields */}
        {renderTextField(
          "Enter CIN",
          "corporateIdentityNumber",
          "1. Corporate Identity Number (CIN) of the Listed Company"
        )}
        {renderTextField(
          "Enter Name",
          "listedCompanyName",
          "2. Name of the Listed Company"
        )}
        {renderYearPicker("3. Year of Incorporation", "yearOfIncorporation")}
        {renderTextField(
          "Enter Address",
          "registeredOfficeAddress",
          "4. Registered Office Address"
        )}
        {renderTextField(
          "Enter Address",
          "corporateOfficeAddress",
          "5. Corporate Office Address"
        )}
        {renderTextField(
          "Enter Email",
          "companyEmail",
          "6. Company E-mail ID",
          "email"
        )}
        {renderTextField(
          "Enter Number",
          "companyTelephoneNumber",
          "7. Company Telephone Number"
        )}
        {renderTextField(
          "Enter Website",
          "companyWebsite",
          "8. Company Website"
        )}
        {/* {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>} */}
        {renderYearPicker(
          "9. Financial year for which reporting is being done",
          "financialYear"
        )}
        {renderMultiSelect({ hide })}
        {renderTextField(
          "INR",
          "paidUpCapital",
          "11. Paid Up Capital",
          "number"
        )}
        <Grid item xs={12} md={6} className="keep-together">
          <p>
            12. Name and contact details of the person who may be contacted in
            case of any queries on the BRSR report
          </p>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <TextField
              fullWidth
              disabled={disabled}
              name="queryContact.name"
              placeholder="Enter Name"
              size="small"
              value={formData.queryContact.name}
              onChange={handleInputChange}
              error={!!error["name"]} // Show error if exists
              helperText={error["name"] || ""}
              FormHelperTextProps={{
                sx: {
                  marginLeft: 0, // ✅ removes left margin
                },
              }}
            />
            <TextField
              fullWidth
              disabled={disabled}
              name="queryContact.telephone"
              placeholder="Enter Telephone Number"
              size="small"
              value={formData.queryContact.telephone}
              onChange={handleInputChange}
              error={!!error["telephone"]} // Show error if exists
              helperText={error["telephone"] || ""}
              FormHelperTextProps={{
                sx: {
                  marginLeft: 0, // ✅ removes left margin
                },
              }}
            />
            <TextField
              fullWidth
              disabled={disabled}
              name="queryContact.email"
              size="small"
              placeholder="Enter Email"
              value={formData.queryContact.email}
              onChange={handleInputChange}
              type="email"
              error={!!error["email"]} // Show error if exists
              helperText={error["email"] || ""}
              FormHelperTextProps={{
                sx: {
                  marginLeft: 0, // ✅ removes left margin
                },
              }}
            />
          </div>
        </Grid>
        <Grid item xs={12}>
          <p>
            13. Reporting boundary - Are the disclosures under this report made
            on a standalone basis (i.e. only for the entity) or on a
            consolidated basis (i.e. for the entity and all the entities which
            form a part of its consolidated financial statements, taken
            together).
          </p>
          <RadioGroup
            row
            name="reportingBoundary"
            disabled={disabled}
            value={formData.reportingBoundary}
            onChange={handleInputChange}
          >
            <FormControlLabel
              value="Standalone"
              control={<Radio disabled={disabled} />}
              label="Standalone"
            />
            <FormControlLabel
              value="Consolidated"
              control={<Radio disabled={disabled} />}
              label="Consolidated"
            />
          </RadioGroup>
        </Grid>
        {renderTextField(
          " Enter Name",
          "assuranceProvider",
          "14. Name of Assurance Provider"
        )}
        {renderTextField(
          "Enter Type",
          "assuranceType",
          "15. Type of assurance obtained"
        )}
        {!hide && (
          <>
            {brsrReview ? (
              <Box sx={{ ml: "1rem", width: "100%" }}>
                <ReviewBox
                  url={`/brsr/review/${id}`}
                  handleSubmit={handleSubmit}
                />
              </Box>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  padding: "1rem 0",
                  width: "100%",
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </div>
            )}
          </>
        )}{" "}
      </Grid>
    </div>
  );
};

export default Details;
